import { PRILPriority, PRILStatus } from "@/constants/request/PRILConstants";
import {Direction} from "@/dto/request/pril/PRIL_DTO";

export default class PRILFilter {
  pageSize = 20;
  pageNumber = 1;
  letterDateFrom: Date | null = null;
  letterDateTo: Date | null = null;
  createDateFrom: Date | null = null;
  createDateTo: Date | null = null;
  customerId: number | null = null;
  status: PRILStatus | null = null;
  sender: number | null = null;
  assignee: number | null = null;
  letterType: number | null = null;
  priority: PRILPriority | null = null;
  phantom: boolean | null = null;
  archived = false;
  direction: Direction | null = null;
}
